var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"support nav-spcr"},[_c('h1',{staticClass:"text-center text-title-1 mt-5 mb-4"},[_vm._v("Support")]),_c('VueFaqAccordion',{staticClass:"mx-auto",attrs:{"items":_vm.myItems,"activeColor":_vm.activeColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }